import { useState, useEffect } from 'react';

interface MediaQueryParams {
  min?: number;
  max?: number;
}

export function useMediaQuery({ min, max }: MediaQueryParams): boolean {
  let queryString = '';

  if (min) {
    queryString = `(min-width: ${min}px)`;
  }

  if (min && max) {
    queryString = `${queryString} and `;
  }

  if (max) {
    queryString = `${queryString}(max-width: ${max}px)`;
  }

  const [matches, setMatches] = useState<boolean>(window.matchMedia(queryString).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(queryString);
    const documentChangeHandler = (e: MediaQueryListEvent) => setMatches(e.matches);

    mediaQueryList.addEventListener('change', documentChangeHandler);

    return () => {
      mediaQueryList.removeEventListener('change', documentChangeHandler);
    };
  }, [queryString]);

  return matches;
}
